import { useIoContext } from '~/contexts';
import { useEventReporter } from '~/event-reporter';
import { LoginMethod } from './loginMethod';
import { makePendingLoginMethodStorage } from './pendingLogin';
export { LoginMethod };
const OUTCOMES_THAT_NEVER_REACH_A_SESSION = [
    'canceled',
    'failed'
];
export function useLoginTelemetry() {
    const { sessionStorage, getNow } = useIoContext();
    const { sendEventToGtm } = useEventReporter();
    const pendingLogin = ()=>makePendingLoginMethodStorage(sessionStorage, getNow);
    return {
        loginSucceeded: (method)=>pendingLogin().persistPendingMethod(method),
        loginFailed: (method, failReason)=>sendEventToGtm('login_fail', {
                method,
                fail_reason: failReason || 'unknown'
            }),
        loginAttempted: async (method, attempt)=>{
            pendingLogin().persistPendingMethod(method);
            const outcome = await attempt();
            if (OUTCOMES_THAT_NEVER_REACH_A_SESSION.includes(outcome)) {
                pendingLogin().clearPendingMethod();
            }
            return outcome;
        }
    };
}
